export const generateRandomString = (complexity = 3) => {
  return Array.apply(null, Array(complexity))
    .map(() => {
      return Math.random()
        .toString(36)
        .slice(2);
    })
    .join('');
};
